import { useState } from 'react';
import {
  DtoolsImportRows,
  PortalioImportRows,
} from 'src/components/ImportProposalsModal/import-rows';
import type { ImportListRow } from 'src/components/ImportProposalsModal/use-import-list-rows';
import { ModalStep } from 'src/components/ModalContainer';

export type ImportSource = 'portalio' | 'dtools';

const SOURCE_TITLES: Record<ImportSource, string> = {
  portalio: 'Import from portal.io',
  dtools: 'Import from D-Tools Cloud',
};

interface ImportItemsStepProps {
  source: ImportSource;
  onImport: (items: ImportListRow[]) => void;
  onCancel: () => void;
}

/** Step 2: pick the proposals or projects to import; the selection survives search and paging. */
export const ImportItemsStep = ({ source, onImport, onCancel }: ImportItemsStepProps) => {
  const [selected, setSelected] = useState<ImportListRow[]>([]);
  const Rows = source === 'portalio' ? PortalioImportRows : DtoolsImportRows;

  return (
    <ModalStep
      title={SOURCE_TITLES[source]}
      actions={[
        { label: 'Cancel', kind: 'secondary', onClick: onCancel },
        {
          label: selected.length ? `Import (${selected.length})` : 'Import',
          kind: 'primary',
          onClick: () => onImport(selected),
          disabled: selected.length === 0,
          testId: 'import-proposals-import',
        },
      ]}
    >
      <Rows selected={selected} onSelectedChange={setSelected} />
    </ModalStep>
  );
};
